import { render } from "./EmptySection.vue?vue&type=template&id=307f0de7"
import script from "./EmptySection.vue?vue&type=script&lang=js"
export * from "./EmptySection.vue?vue&type=script&lang=js"
script.render = render

export default script